import React, { Component } from "react";
import {
  NavBar,
  Icon,
  List,
  WhiteSpace,
  InputItem,
  Button,
  WingBlank,
  TextareaItem,
  Toast,
} from "antd-mobile";
import { connect } from "dva";
import "./addGroup.scss";
import SelectUser from "./selectUser";
import axios from "../../../service/axios";
import { createForm } from "rc-form";
let Item = List.Item;
const selectedContainer = {
  position: "fixed",
  width: "100%",
  top: "0",
  background: "#f5f5f5",
  height: "100%",
  zIndex: "11",
  transition: "left 0.4s",
};
export class AddGroup extends Component {
  state = {
    groupErr: "",
    drawerLeft: document.body.clientWidth,
    name: "",
  };
  componentDidMount() {
    if (this.props.match.params.type == "edit") {
      this.getGroupUserList();
      this.setState({
        name: this.props.match.params.name,
      });
    }
  }
  onAddGroup() {
    this.props.form.validateFields({ force: true }, error => {
      console.log(this.props.form.getFieldsValue());
      if (!error) {
        // if (this.props.selectUserList.length < 1) {
        //   Toast.info("请选择群组成员",1);
        //   return;
        // }
        this.addGroup(this.props.form.getFieldsValue());
      }
    });
  }
  addGroup(data) {
    let type = this.props.match.params.type == "edit" ? "update" : "add";
    axios
      .post("/api/group/" + type, {
        ...data,
        users: this.props.selectUserListUidArr,
        gid: this.props.match.params.gid,
      })
      .then(res => {
        if (res) {
          if (res.status == 200) {
            Toast.success(res.message, 1, () => {
              this.props.setEmpty();
              this.props.history.replace("/grouplist");
            });
          } else {
            Toast.fail(res.message);
          }
        }
      })
      .catch(res => {
        Toast.hide();
      });
  }
  DYcamera = () => {
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        var result =  res.resultStr.split(',')[1];
        this.getSaomaState(result)
      }
    })
  };

  getSaomaState(iccid){
    axios.post("/api/group/realtion/user", {
      gids: [this.props.match.params.gid],
      iccids: [iccid]
    })
    .then(res => {
      if (res && res.status == 200) {
        Toast.success(res.message, 1, () => {
          this.getGroupUserList();
        });
      }
      else{
        Toast.fail(res.message);
      }
    })
  }
  getGroupUserList() {
    axios
      .get("/api/group/members", {
        params: {
          gid: this.props.match.params.gid,
          pageNo: 1,
          pageSize: 3000,
        },
      })
      .then(res => {
        if (res && res.status == 200 && res.data) {
          this.props.setSelectUserList(res.data.resultList || []);
        }
      });
  }
  validaetName = (rule, value, callback) => {
    if (value) {
      if (value.trim()) {
        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,11}$/.test(value)) {
          callback();
        } else {
          callback(new Error("名称只支持1~11位中文数字字母和下划线"));
        }
      } else {
        callback(new Error("请填写群组名"));
      }
    } else {
      callback(new Error("请填写群组名"));
    }
  };
  render() {
    const { selectUserList } = this.props;
    const { groupErr, drawerLeft } = this.state;
    const { getFieldProps, getFieldError } = this.props.form;
    const { name } = this.state;
    const remarks = sessionStorage.getItem("groupRemarks");
    const userMsg =
      sessionStorage.getItem("loginMsg") &&
      JSON.parse(sessionStorage.getItem("loginMsg"));
    return (
      <div className="addgroup">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            {this.props.match.params.type == "edit" ? name : "群组添加"}
          </NavBar>
        </div>
        <div className="sub-container">
          <List renderFooter={() => getFieldError("name") || groupErr}>
            <InputItem
              {...getFieldProps("name", {
                rules: [
                  {
                    validator: this.validaetName,
                  },
                ],
                initialValue: name,
              })}
              clear
              ref={el => (this.autoFocusInst = el)}
              maxLength="11"
              placeholder="请填写群组名"
            >
              群组名字
            </InputItem>
            <Item
              ref={el => (this.autoFocusInst = el)}
              arrow="horizontal"
              onClick={() =>
                this.setState({
                  drawerLeft: 0,
                })
              }
              extra={
                selectUserList.length > 0
                  ? `已选${selectUserList.length}个成员`
                  : "请选择组员"
              }
            >
              群组成员
            </Item>
            <TextareaItem
              {...getFieldProps("remarks", {
                initialValue: remarks,
              })}
              title="备注"
              placeholder=""
              data-seed="logId"
              ref={el => (this.autoFocusInst = el)}
              autoHeight
            />
          </List>
          <WhiteSpace size="xl" />
          <WingBlank>
            {userMsg.userType >= 1 && userMsg.userType <= 3 ? (
              ""
            ) : this.props.match.params.type == "edit" ? (
              <div>
                <Button type="primary" onClick={() => this.onAddGroup()}>
                  修改
                </Button>
                <WhiteSpace size="xl" />
                <Button
                  type="primary"
                  onClick={() =>
                    this.props.history.push(
                      `/groupuserlist/${this.props.match.params.gid}/${name}`,
                    )
                  }
                >
                  成员优先级
                </Button>
                <WhiteSpace size="xl" />
                {/* <Button type="primary" onClick={() => this.DYcamera()}>
                  扫码进群
                </Button> */}
              </div>
            ) : (
                  <Button type="primary" onClick={() => this.onAddGroup()}>
                    确定
                  </Button>
                )}
          </WingBlank>
          <WhiteSpace size="xl" />
          <WingBlank>
            <Button onClick={() => this.props.history.goBack()}>返回</Button>
          </WingBlank>
          <WhiteSpace size="xl" />
        </div>
        <div
          style={{
            ...selectedContainer,
            left: drawerLeft + "px",
          }}
        >
          <SelectUser
            closeDrawer={() => {
              this.setState({
                drawerLeft: document.body.clientWidth,
              });
            }}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    selectUserList: state.userSelectList.selectUserList,
    selectUserListUidArr: state.userSelectList.selectUserListUidArr,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setSelectUserList: data => {
      dispatch({
        type: "userSelectList/setSelectUserList",
        data,
      });
    },
    setEmpty: data => {
      dispatch({
        type: "userSelectList/deleteSelectUserList",
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(createForm()(AddGroup));
